import { render, staticRenderFns } from "./assessmentCyclePage.vue?vue&type=template&id=023bf7f2&scoped=true"
import script from "./assessmentCyclePage.vue?vue&type=script&lang=js"
export * from "./assessmentCyclePage.vue?vue&type=script&lang=js"
import style0 from "./assessmentCyclePage.vue?vue&type=style&index=0&id=023bf7f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023bf7f2",
  null
  
)

export default component.exports